import React from 'react';
import { industries } from '../utils/mockData';
import { 
  Paintbrush, 
  Package, 
  Layers, 
  ShoppingBag, 
  Gem, 
  FileText, 
  Factory,
  Sparkles,
  Shirt,
  Square
} from 'lucide-react';

const iconMap = {
  Paintbrush,
  Package,
  Pipe: Layers,
  ShoppingBag,
  Gem,
  FileText,
  Factory,
  Sparkles,
  Shirt,
  Square
};

const IndustriesSection = () => {
  return (
    <section id="industries" className="py-24 bg-white relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.pexels.com/photos/14804699/pexels-photo-14804699.jpeg" 
          alt="Manufacturing Facility"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-manufacturing-orange/10 text-manufacturing-orange px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Industries We Serve
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-bharat-blue mb-6">
            Powering 20+ Manufacturing Sectors
          </h2>
          <p className="text-xl text-steel-grey max-w-3xl mx-auto">
            Our diversified customer base across industries ensures steady demand cycles and reduces concentration risk
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {industries.map((industry, index) => {
            const Icon = iconMap[industry.icon];
            return (
              <div 
                key={industry.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg border-2 border-gray-100 hover:border-manufacturing-orange transition-all duration-300 group hover:shadow-2xl hover:-translate-y-1"
              >
                {/* Industry Image */}
                <div className="relative h-40 overflow-hidden">
                  <img 
                    src={industry.imageUrl} 
                    alt={industry.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-bharat-blue/80 to-transparent"></div>
                  <div className="absolute bottom-3 left-3">
                    <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                  </div>
                </div>
                {/* Content */}
                <div className="p-5">
                  <h3 className="text-lg font-bold text-bharat-blue mb-2">
                    {industry.name}
                  </h3>
                  <p className="text-steel-grey text-sm leading-relaxed">
                    {industry.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom Statement */}
        <div className="bg-gradient-to-r from-bharat-blue to-bharat-blue/90 rounded-2xl p-8 md:p-12 text-center shadow-xl">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Serving SME & MSME Manufacturers Across North India
          </h3>
          <p className="text-white/90 text-lg max-w-3xl mx-auto">
            Our supply partnerships are built on understanding your production cycles, 
            quality requirements, and delivery timelines.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
